import CategoryBySlug from "@/pages/home/discover/components/CategoryBySlug";
import Search from "@/pages/search";

const SearchRoutes = [
  { path: "/search", element: <Search /> },

  /** Theme categories */
  { path: "/search/:search_type/:search_item", element: <CategoryBySlug /> },
];

export default SearchRoutes;
